import { jsx as _jsx } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2023 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { Header } from "../index";
var home = {
    href: "/",
    text: "Go back home"
};
function PageNotFound() {
    return (_jsx(Header, { title: "Oops! You seem to be lost.", buttons: [home], pageEmpty: true }));
}
export default PageNotFound;
